import React from "react";

interface Props {
  image: any;
  className: string;
}

export const ImageElement = ({ image, className }: Props) => {
  return (
    <img
      src={image}
      alt="image"
      className={className}
      style={{ paddingRight: 5 }}
    />
  );
};

export default ImageElement;
